<template>
    <v-container app :fluid="true" class="pt-0">
        <v-row>
            <v-col cols="3">
                <v-autocomplete
                    v-model="form.provider_id"
                    :items="providers"
                    dense
                    solo
                    clearable 
                    clear-icon="far fa-times-circle"               
                    label="Proveedores"
                    persistent-hint
                    :item-text="customText"
                    item-value="id"
                    hide-details
                    @change="handleSelecteProvider"
                    :filter="customFilter"
                    >
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                <v-list-item-subtitle>RUC: {{ data.item.document }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                </v-autocomplete>
            </v-col>

            <v-col cols="3">
                <v-menu
                    v-model="menuFromDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="form.from_date"
                            label="Desde"
                            readonly
                            solo
                            dense
                            clearable
                            v-on="on"
                            @click:clear="handleClearFrom"
                            hide-details                                    
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.from_date" 
                        @input="menuFromDate = false" 
                        no-title 
                        locale="es"
                        @change="handleChangeFormDate">
                    </v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="3">
                <v-menu
                    v-model="menuUntilDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="form.until_date"
                        label="Hasta"
                        solo
                        dense
                        readonly
                        clearable
                        v-on="on"
                        @click:clear="handleClearUntil"
                        hide-details
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.until_date" 
                        @input="menuUntilDate = false" 
                        no-title 
                        locale="es"
                        @change="handleChangeUntilDate"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="3">
                <v-btn dark color="green" 
                    @click="handleExportExcel">
                    XLS
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="importations"
                        item-key="id"
                        height="65vh"
                        show-expand
                        :single-expand="true"
                        fixed-header
                    >

                        <template v-slot:item.voucher_date="{item}">
                            <v-icon size="18" class="mr-2" color="amber">
                                far fa-calendar-alt
                            </v-icon>
                            <span>{{ item.voucher_date | moment('DD/MM/YYYY') }}</span>
                        </template>

                        <template v-slot:item.provider_id="{item}">
                            <span v-if="item.provider">
                                {{ item.provider.name }}
                            </span>
                        </template>

                        <template v-slot:item.total="{item}">
                            <span class="label-amount-importation">
                                {{ item.total | currency('S/') }}
                            </span>
                        </template>

                        <template v-slot:expanded-item="{ item, headers }">
                            <td :colspan="headers.length" class="wost-td-expanded">
                                <importation-detail :importation="item"></importation-detail>
                            </td>
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';

import XLSX from 'xlsx'

import ImportationDetail from '../../components/Reports/ImportationDetail';
import Tools from '../../helpers/Tools';

import {APIService} from '@/APIService';

const apiService = new APIService();

export default {
    name: 'Importations',
    components: {
        ImportationDetail
    },
    data () {
        return {
            headers: [
                { text: 'Fecha', value: 'voucher_date', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Proveedor', value: 'provider_id', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Total', value: 'total', align: 'left', sortable: false, class: 'header-table' },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ],
            providers: [],
            menuFromDate: false,
            menuUntilDate: false,
            form: {
                provider_id: null,
                from_date: null,
                until_date: null
            }
        }
    },
    computed: {
        ...mapState('importations', [
            'importations'
        ])
    },
    methods: {
        ...mapActions('importations', [
            'getImportations'
        ]),
        customText(item){
            let text = item.name
            
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();             
            }

            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();             
            }
            let searchText = queryText.toLowerCase()

            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        getProviders() {
            apiService.getProviders()
                .then(({data}) => {
                    this.providers = data
                })
        },
        handleSelecteProvider(value){            
            this.form.provider_id = null            
            if(value !== undefined && value !== null){
                this.form.provider_id = value
            }
            this.getImportations(this.form);
        },
        handleClearFrom(){
            this.form.from_date = null
            this.getImportations(this.form);
        },
        handleChangeFormDate(){
            this.getImportations(this.form);
        },
        handleClearUntil(){
            this.form.until_date = null
            this.getImportations(this.form);
        },
        handleChangeUntilDate(){
            this.getImportations(this.form);
        },
        handleExportExcel(){
            let data = XLSX.utils.json_to_sheet(
                this.prepareDataExport(this.importations),
                {
                    header: [
                        'voucher_date', 
                        'provider',
                        'total'
                    ]
                }
            )
            data['A1'].v = 'Fecha de importación'
            data['B1'].v = 'Proveedor'
            data['C1'].v = 'Total'
            const workbook = XLSX.utils.book_new()
            const filename = 'reporte-de-importación'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xls`)
        },
        prepareDataExport(importations){
            let dataExport = []
            importations.forEach(element => {
                
                let itemData = {
                    voucher_date: Tools.setFormatDate(new Date(element.voucher_date)),
                    provider: element.provider.name,
                    total: element.total,
                }
                dataExport.push(itemData)
            })
            return dataExport
        },
    },
    created () {
        this.getImportations();
        this.getProviders();
    }
}
</script>

<style scoped>
.label-amount-importation {
    display: inline-block;
    width: 110px;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    border: 1px solid #4CAF50;
    color: #4CAF50;
    font-weight: bold;
}
</style>